var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function () {
        return [_c('sub-visual', {
          attrs: {
            "sh": "태성 이혼가사팀 성공사례",
            "bg": "/images/sub/visual/sv-reference.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', [_c('reference-view')], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }